// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2sFDI","right":"styles_right__2RmFB"};